import React from 'react'
import FashionDesignCompany from '../Home/components/FashionDesignCompany'
import ComprehendYourStyle from '../Home/components/ComprehendYourStyle'
import PageHeading from '../../layout/PageHeading'
import CarouselComponent from './components/CarouselComponent'
import ProductBrands from './components/ProductBrands'
import TailorsDesigners from './components/TailorsDesigners'

const About = () => {
    return (
        <>
            <PageHeading title={'About Us'} />
            {/* <FashionDesignCompany /> */}
            <ComprehendYourStyle />
            {/* <TailorsDesigners/> */}
            {/* <ProductBrands /> */}
            <CarouselComponent/>
        </>
    )
}

export default About